import { createFileRoute } from '@tanstack/react-router';

import { MainTenderPage } from '@/features/owner/tenders-page';

export const Route = createFileRoute('/_app/projects/$projectId/tenders/$packageId')({
  component: PageRoute,
});

function PageRoute() {
  const { projectId, packageId } = Route.useParams();
  return <MainTenderPage projectId={projectId} packageId={packageId} />;
}
